import React, { useEffect, useRef } from "react";

/**
 * Embeds TradingView's free "Mini Chart" widget.
 * symbol example: "NASDAQ:AAPL"
 */
export default function TradingViewChart({ symbol, height = 280, dateRange = "12M" }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.innerHTML = "";

    const widget = document.createElement("div");
    widget.className = "tradingview-widget-container__widget";
    container.appendChild(widget);

    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbol,
      width: "100%",
      height: "100%",
      locale: "en",
      dateRange,
      colorTheme: "light",
      isTransparent: true,
      autosize: true,
      largeChartUrl: "",
    });
    container.appendChild(script);

    // Clean up when the symbol changes or the component unmounts
    return () => {
      container.innerHTML = "";
    };
  }, [symbol, dateRange]);

  return (
    <div
      className="tradingview-widget-container"
      ref={containerRef}
      style={{ height, width: "100%" }}
    />
  );
}